export var defaultMonthOptions = {
    width: 7,
    height: 6
};
